import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MasterData from '../../data/MasterData'
import stationImages from '../../assets/images/station_Info/*.svg'
import restroomImages from '../../assets/images/restroom/*.svg'
import RestroomMasterData from '../../data/RestroomMasterData'

class Restroom extends React.Component {
  static propTypes = {
    lines: PropTypes.array.isRequired,
    restrooms: PropTypes.array.isRequired,
    fetchLines: PropTypes.func.isRequired,
    fetchRestrooms: PropTypes.func.isRequired
  }

  async componentDidMount() {
    const { fetchLines, fetchRestrooms } = this.props
    const { stationId } = this.props.match.params
    if (this.props.lines.length === 0) {
      await fetchLines()
    }

    await fetchRestrooms()
  }

  lineKind() {
    const { stationId } = this.props.match.params
    return MasterData.lineKind(stationId)
  }

  stations() {
    const { lines } = this.props
    const { lineName } = this.props.match.params
    const lineId = MasterData.lineIdByLineName(lineName)
    return lines
      .find(l => l.line_id === lineId)
      .stations.concat(lines.find(l => l.line_id === lineId + 2).stations)
  }

  getStationImage(ekiNumber) {
    let stationNamePath = ''
    const lineKind = this.lineKind()
    if (lineKind === 'senboku') {
      stationNamePath = 'station_senboku_stationnumber_sb'
    } else {
      stationNamePath = `station_${lineKind}_stationnumber_nk`
    }
    const stationImage = `${stationNamePath}${ekiNumber}`
    return stationImages[stationImage]
  }

  getRestRoomStatus(stall) {
    const {restrooms} = this.props

    return restrooms.find(restroom => {
      return restroom['placeIdHash'] == stall.placeIdHash
    })
  }

  getToiletType(status) {
    return status.attachmentGroupList.find((group) => group.name == 'toiletType').attachmentList[0].attachmentType
  }

  // 駅情報表示
  renderStationInfo(facilities) {
    const { stationId } = this.props.match.params
    if (!stationId) return null
    const station = this.stations().find(station => station.id == stationId)
    const stationImage = this.getStationImage(station.eki_number)
    const facilityNames = facilities.map(facility => facility.name)

    return (
      <div className='c-Restroom-stationInfo'>
        <div className='c-Restroom-stationInfo-name'>
          <img src={stationImage} />
          <div>{station.name_ja}</div>
        </div>
        <div className='c-Restroom-stationInfo-facilities'>{facilityNames.join('/')}</div>
      </div>
    )
  }

  // 凡例表示
  renderLegend() {
    return (
      <div className='c-Restroom-legend'>
        <div className='c-Restroom-legend-main'>
          <div className='c-Restroom-legend-main-text'>空きあり：</div><img className='c-Restroom-legend-main-image' src={restroomImages['restroom_ic_aki']} />
          <div className='c-Restroom-legend-main-text'>満室：</div><img className='c-Restroom-legend-main-image' src={restroomImages['restroom_ic_manshitsu']} />
          <div className='c-Restroom-legend-main-text'>空個室数／総個室数</div>
        </div>
        <div className='c-Restroom-legend-note'>
          空き状況はリアルタイムには反映されません。更新ボタンをタップし、最新情報をご確認ください。
        </div>
      </div>

    )
  }

  // 施設空き状況表示
  renderFacility(facility) {
    return (
      <li className='c-Restroom-facility' key={facility.name}>
        <div className='c-Restroom-facility-header'>
          {facility.name}
        </div>
        <ul>
          {
            facility.rooms.map( room => {
              return this.renderRoom(facility.id, room)
            })
          }
        </ul>
      </li>
    )
  }

  // トイレ表示
  renderRoom(facilityId, room) {
    const { pathname } = this.props.location
    let roomClosedStatus = undefined

    if (!RestroomMasterData.isOpenAtRoom(room)) {
      roomClosedStatus = 'closed'
    } else {
      for(let stall of room.stalls) {
        const status = this.getRestRoomStatus(stall)
        if(!status) {
          roomClosedStatus = 'unknown'
          break
        }
        if(['unknown'].some(value => value == status.vacancy.status)) {
          roomClosedStatus = status.vacancy.status
          break
        }
      }
    }

    let roomName = this.getRestRoomStatus(room.stalls[0]).name
    switch (roomName) {
      case '1Fムシベジプラスカフェ横トイレ':
        roomName = '1F東側トイレ'
        break
      case '1Fル タロン横トイレ':
        roomName = '1F北側トイレ'
        break
      case 'B1Fテチチ横トイレ':
        roomName = 'B1F西側トイレ'
        break
      case 'B1Fアフタヌーンティー・リビング横トイレ':
        roomName = 'B1F東側トイレ'
        break
      case 'B2Fユザワヤ横トイレ':
        roomName = 'B2F北側トイレ'
        break
      case 'B2Fドクターストレッチ横トイレ':
        roomName = 'B2F西側トイレ'
        break
    }

    return (
      <li className='c-Restroom-room' key={room.id}>
        <div className='c-Restroom-roomName'>
          <div className='c-Restroom-roomName-text'>{roomName}</div>
          {
            room.map_image_name ? (
              <Link className='c-Restroom-map-link' to={`${pathname}/facilities/${facilityId}/rooms/${room.id}/map`}><img src={restroomImages['restroom_btn_map']} alt=''/></Link>
            ) : ('')
          }
        </div>
        {
          !roomClosedStatus ? (
            <ul className='c-Restroom-stalls'>
            {
              room.stalls.map( stall => {
                return this.renderStall(stall)
              })
            }
            </ul>
          ) : (
            this.renderClosedRoom(roomClosedStatus, room)
          )
        }
      </li>
    )
  }

  // 個室表示
  renderStall(stall) {
    const status = this.getRestRoomStatus(stall)
    if (!status) {
      return
    }
    const count = status.vacancy.countText.split('/')

    // なんば駅2F中央改札トイレ工事中表示対応
    if (status.name == '2F中央改札トイレ' && this.isConstruction()) {
      status.vacancy.status = 'maintenance'
    }
    // なんば駅2F中央改札トイレ工事中表示対応 ここまで

    const isMaintenance = status.vacancy.status == 'maintenance'
    const stallType = RestroomMasterData.stallTypeAtToiletType(this.getToiletType(status))

    return (
      <li className={`c-Restroom-stall${!isMaintenance?'':' is-restroom-closed'}`} key={stall.placeIdHash}>
        {
          !isMaintenance ? (
            <div className='c-Restroom-stall-open'>
              <div className='c-Restroom-stall-open-icon'>
                <img src={restroomImages[RestroomMasterData.stallIconName(stallType, count[0] == 0)]}/>
              </div>
              <div className='c-Restroom-stall-open-count'>
                空き<strong className={(count[0] == 0)?'is-full':''}>{count[0]}</strong>/{count[1]}
              </div>
            </div>
          ) : (
            <img src={restroomImages[RestroomMasterData.koujichuIconName(stallType)]}/>
          )
        }
      </li>
    )
  }

  // トイレ工事中表示対応
  isConstruction() {
    const maintenanceStart = new Date(2022, 5, 2, 9)
    const maintenanceEnd = new Date(2022, 5, 4, 10)
    const now = new Date(Date.now())

    if (now >= maintenanceStart && now <= maintenanceEnd ) {
      return true
    }

    return false
  }

  //トイレ異常状態表示
  renderClosedRoom(status, room) {
    // なんば駅2F中央改札トイレ工事中表示対応
    if (room.note === '2F中央改札' && this.isConstruction()) {
      return(
        <ul className='c-Restroom-stalls'>
        {
          room.stalls.map( stall => {
            return this.renderStall(stall)
          })
        }
        </ul>
      )
    }
    // なんば駅2F中央改札トイレ工事中表示対応 ここまで

    let imageName
    switch (status) {
      case 'unknown':
        imageName = 'choseichu'
        break
      case 'closed':
        imageName = 'closed'
        break
      default:
    }
    imageName = `restroom_img_${imageName}`
    return (
      <div className='c-Restroom-room-closed is-restroom-closed'>
        <img src={restroomImages[imageName]}/>
      </div>
    )
  }

  render() {
    const { lines, restrooms } = this.props
    const { stationId } = this.props.match.params

    if (lines.length == 0 ) return null
    if (!stationId) return null

    const facilities = RestroomMasterData.facilitiesAtStation(stationId)
    if (!facilities) return null

    return (
      <div className={`c-Restroom is_${this.lineKind()}_${this.stationId}`}>
        {this.renderStationInfo(facilities)}
        {this.renderLegend()}
        {
          restrooms.length > 0 ? (
            <ul className='c-Restroom-facilities'>
            {
              facilities.map( facility => {
                return this.renderFacility(facility)
              })
            }
          </ul>
          ) : ('')
        }
      </div>
    )
  }
}

export default Restroom
